export enum Genres {
    AcidHouse = 'acid_house',
    African = 'african',
    Afrobeats = 'afrobeats',
    AfroHouse = 'afro_house',
    Amapiano = 'amapiano',
    Ambient = 'ambient',
    Asian = 'asian',
    Blues = 'blues',
    BoomBap = 'boom_bap',
    BossaNova = 'bossa_nova',
    Brazilian = 'brazilian',
    Caribbean = 'caribbean',
    ChillOut = 'chill_out',
    Cinematic = 'cinematic',
    ClassicRnb = 'classic_rnb',
    Classical = 'classical',
    Country = 'country',
    Cuban = 'cuban',
    Dancehall = 'dancehall',
    DeepHouse = 'deep_house',
    Disco = 'disco',
    Downtempo = 'downtempo',
    Drill = 'drill',
    DrumBass = 'drum_bass',
    Dubstep = 'dubstep',
    Edm = 'edm',
    Electro = 'electro',
    Electropop = 'electropop',
    Folk = 'folk',
    Funk = 'funk',
    FutureHouse = 'future_house',
    Garage = 'garage',
    Gospel = 'gospel',
    Grime = 'grime',
    Hardstyle = 'hardstyle',
    House = 'house',
    Hyperpop = 'hyperpop',
    Idm = 'idm',
    Indian = 'indian',
    IndieRock = 'indie_rock',
    Jazz = 'jazz',
    JerseyClub = 'jersey_club',
    Jungle = 'jungle',
    Kpop = 'k_pop',
    LoFi = 'lo_fi',
    Metal = 'metal',
    MiddleEastern = 'middle_eastern',
    Minimal = 'minimal',
    Moombahton = 'moombahton',
    Phonk = 'phonk',
    Pop = 'pop',
    PostPunk = 'post_punk',
    ProgressiveHouse = 'progressive_house',
    Psytrance = 'psytrance',
    Punk = 'punk',
    Reggae = 'reggae',
    Reggaeton = 'reggaeton',
    Rnb = 'rnb',
    Rock = 'rock',
    SlapHouse = 'slap_house',
    Soul = 'soul',
    Synthwave = 'synthwave',
    TechHouse = 'tech_house',
    Techno = 'techno',
    Trance = 'trance',
    Trap = 'trap',
    Triphop = 'triphop',
    TropicalHouse = 'tropical_house',
    VideoGame = 'video_game',
    WestCoast = 'west_coast',
    AlternativeRock = 'alternative_rock',
    AmbientTechno = 'ambient_techno',
    Bachata = 'bachata',
    BaileFunk = 'baile_funk',
    Bassline = 'bassline',
    BassHouse = 'bass_house',
    Bebop = 'bebop',
    BedroomPop = 'bedroom_pop',
    BigBand = 'big_band',
    BluesRock = 'blues_rock',
    Bollywood = 'bollywood',
    Boogie = 'boogie',
    Bounce = 'bounce',
    Breakbeat = 'breakbeat',
    Breakcore = 'breakcore',
    BrokenBeat = 'broken_beat',
    Chillhop = 'chillhop',
    Chillwave = 'chillwave',
    Chiptune = 'chiptune',
    ChoppedAndScrewed = 'chopped_and_screwed',
    CityPop = 'city_pop',
    Coldwave = 'coldwave',
    CorridosTumbados = 'corridos_tumbados',
    CountryRap = 'country_rap',
    CountryRock = 'country_rock',
    Cumbia = 'cumbia',
    DarkElectro = 'dark_electro',
    DarkWave = 'dark_wave',
    DeathMetal = 'death_metal',
    DreamPop = 'dream_pop',
    Drone = 'drone',
    Dub = 'dub',
    DubTechno = 'dub_techno',
    Ebm = 'ebm',
    Electronica = 'electronica',
    ElectroSwing = 'electro_swing',
    Emo = 'emo',
    EmoRap = 'emo_rap',
    Experimental = 'experimental',
    Flamenco = 'flamenco',
    Footwork = 'footwork',
    Freestyle = 'freestyle',
    FreeJazz = 'free_jazz',
    FutureBass = 'future_bass',
    FutureFunk = 'future_funk',
    GarageRock = 'garage_rock',
    Grunge = 'grunge',
    GHouse = 'g_house',
    Hardcore = 'hardcore',
    HardRock = 'hard_rock',
    HardTechno = 'hard_techno',
    HeavyMetal = 'heavy_metal',
    Hiphop = 'hiphop',
    IndiePop = 'indie_pop',
    Industrial = 'industrial',
    JazzyHiphop = 'jazzy_hiphop',
    JazzRap = 'jazz_rap',
    JPop = 'j_pop',
    Krautrock = 'krautrock',
    LatinJazz = 'latin_jazz',
    Leftfield = 'leftfield',
    MelodicTechno = 'melodic_techno',
    Metalcore = 'metalcore',
    MinimalTechno = 'minimal_techno',
    NeoSoul = 'neo_soul',
    NewWave = 'new_wave',
    NoiseRock = 'noise_rock',
    NuMetal = 'nu_metal',
    Opera = 'opera',
    Perreo = 'perreo',
    Pluggnb = 'pluggnb',
    PopRock = 'pop_rock',
    ProgressiveRock = 'progressive_rock',
    ProgressiveTrance = 'progressive_trance',
    PsychedelicRock = 'psychedelic_rock',
    Rockabilly = 'rockabilly',
    Salsa = 'salsa',
    Samba = 'samba',
    Sfx = 'sfx',
    Shoegaze = 'shoegaze',
    Ska = 'ska',
    SmoothJazz = 'smooth_jazz',
    SurfRock = 'surf_rock',
    Swing = 'swing',
    SynthPop = 'synth_pop',
    Vaporwave = 'vaporwave',
}
